// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/WebApplicationDevelopment","techList":"WebApplicationDevelopment-m__techList__f52bc31ozna"};